export default __webpack_public_path__ + "static/media/typeBoat.adb5bb37.adb5bb37.svg";